import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=0d6f49ca&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=0d6f49ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6f49ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d6f49ca')) {
      api.createRecord('0d6f49ca', component.options)
    } else {
      api.reload('0d6f49ca', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=0d6f49ca&scoped=true&", function () {
      api.rerender('0d6f49ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2XDLlP5BRivlU/JS/comp/PopupBox.vue"
export default component.exports